import type {
    AdminServiceUnsupportedBillingError,
    ThrowUnsupportedAdminServiceBillingParams,
} from '../types';

const throwUnsupportedAdminServiceBilling = ({
    message,
}: ThrowUnsupportedAdminServiceBillingParams): never => {
    const error: AdminServiceUnsupportedBillingError = {
        code: 'SERVICE_BILLING_UNSUPPORTED',
        message,
    };
    throw error;
};

export default throwUnsupportedAdminServiceBilling;
